import React from 'react';
import './App.css';
import Album from './Album';

function App() {
  return (
    <div className="App">
      <Album />
    </div>
  );
}

export default App;
